import { z } from 'zod';

import { DEFAULT_PAGE_NUMBER } from '../../../../../../constants';
import { defaultPagingSchema } from '../../../../../../helpers/schemas/defaultPagingSchema';
import { getClientCardsClickToPayFilterFormSchema } from '../components/ClientCardsClickToPayFilter/helpers/getClientCardsClickToPayFilterFormSchema';

const clientCardsClickToPayFilterFormSchema =
	getClientCardsClickToPayFilterFormSchema();

export const clientCardsClickToPayValidateSearchSchema =
	defaultPagingSchema.extend({
		openedAction: z.string().optional().catch(undefined),
		bankCardUuid: z.string(),
		filter: clientCardsClickToPayFilterFormSchema.optional().catch(undefined),
		pageNumberFromCardsPage: z
			.number()
			.optional()
			.prefault(DEFAULT_PAGE_NUMBER),
	});
